import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchModelsList = createAsyncThunk(
  "fetchModelsList",
  async ({ page, limit, filters }) => {
    const token = localStorage.getItem("auth_token");

    const keyword = filters?.keyword ? filters?.keyword : "";

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    const response = await axiosHttp.get(
      `product/model/list?page=${page}&limit=${limit}`,
      config
    );

    return response.data.data;
  }
);

const ModelListSlice = createSlice({
  name: "modelList",
  initialState: {
    isLoading: false,
    data: [],
    error: null,
    page: 1,
    total: 0,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchModelsList.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchModelsList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.page = action.payload.current_page;
      state.total = action.payload.count;
    });
    builder.addCase(fetchModelsList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default ModelListSlice.reducer;
